import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import AppLayout from '../../components/ui/AppLayout';
import PageHeader from '../../components/ui/PageHeader';
import SectionCard from '../../components/ui/SectionCard';
import countries from './countries';
import api from '../../api';

const RegistrationPage = () => {
  const [formData, setFormData] = useState({
    nome: '',
    pais: '',
    numeroCamisa: '',
    tamanhoCamisa: '',
    nomeConvidado: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value.toUpperCase() });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.pais) {
      setMessage('Selecione o país.');
      setError(true);
      return;
    }
    setLoading(true);
    try {
      const response = await api.post('createSubscription', formData);
      setMessage(response.data.message);
      setError(false);
      setTimeout(() => {
        navigate('/pagamentoInscricao');
      }, 2000);
    } catch (err) {
      setMessage(err.response?.data?.error || 'Erro ao realizar inscrição.');
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppLayout maxWidth="sm">
      <PageHeader backTo="/inscricao" eyebrow="Torneio" title="Inscrição" subtitle="Os dados da camisa são usados na confecção do uniforme." />
      <SectionCard>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField label="Nome na camisa" name="nome" value={formData.nome} onChange={handleChange} required fullWidth />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                options={countries}
                getOptionLabel={(option) => option.label}
                value={countries.find((c) => c.value === formData.pais) || null}
                onChange={(e, option) => setFormData({ ...formData, pais: option ? option.value : '' })}
                renderInput={(params) => <TextField {...params} label="País (seleção que você representa)" required />}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField label="Número da camisa" type="number" name="numeroCamisa" value={formData.numeroCamisa} onChange={handleChange} required fullWidth />
            </Grid>
            <Grid item xs={6}>
              <TextField select label="Tamanho" name="tamanhoCamisa" value={formData.tamanhoCamisa} onChange={handleChange} required fullWidth>
                {['P', 'M', 'G', 'GG'].map((t) => <MenuItem key={t} value={t}>{t}</MenuItem>)}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField label="Nome do convidado (opcional)" name="nomeConvidado" value={formData.nomeConvidado} onChange={handleChange} fullWidth />
            </Grid>
          </Grid>
          <Stack spacing={2} sx={{ mt: 3 }}>
            {message && <Alert severity={error ? 'error' : 'success'}>{message}</Alert>}
            <Button type="submit" variant="contained" size="large" disabled={loading}>
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Confirmar inscrição'}
            </Button>
          </Stack>
        </form>
      </SectionCard>
    </AppLayout>
  );
};

export default RegistrationPage;
